var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlika(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9494ED",
    d: "M23.108 15.77H1.676C.751 15.77 0 15.028 0 14.113V1.657C0 .742.751 0 1.676 0h21.432c.925 0 1.676.742 1.676 1.657v12.456c0 .915-.75 1.657-1.676 1.657",
    transform: "translate(.095 1.02)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3C2F0",
    d: "M0 6.522L24.783 6.522 24.783 3.14 0 3.14zM20.992 12.869h-3.31c-.546 0-.989-.439-.989-.98v-1.424c0-.54.443-.979.99-.979h3.309c.546 0 .989.439.989.979v1.424c0 .541-.443.98-.99.98",
    transform: "translate(.095 1.02)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlika);
export default __webpack_public_path__ + "static/media/slika.bd077cae7b44bdcad089a1e10e9e5745.svg";
export { ForwardRef as ReactComponent };